import userInitialState from "./user.initialstate"
import {
    LOGIN, LOGOUT, SET_LOADING, SET_USERDETAILS,
    SET_LANGUAGE, SET_OTP_TIME, SET_EMAIl_VERIFIED, SET_DARK_MODE, SET_AVAILABILITY, SET_SUPPLIERDETAILS,
    SET_2FA_ENABLED, SET_2FA_VERIFIED, INCREMENT_SUPPLIER_CREDITS, SET_SUPPLIER_CREDITS
} from "./user.types";


const userReducer = (state = userInitialState, action) => {


    switch (action.type) {

        case LOGIN:
            return {
                ...state,
                isLoggedIn: true,
                userDetails: action.payload.userDetails,
                token: action.payload.token,
                language: action.payload.language ?? 'en',
                tempEmail: action.payload.tempEmail,
                // isEmailVerified: action.payload.isEmailVerified ?? false,
                supplierDetails: action.payload.supplierDetails,
                is2faEnabled: action.payload.is2faEnabled,
                permissions: action.payload.permissions,
                isWelcomePageEnabled: action.payload.isWelcomePageEnabled ?? state.isWelcomePageEnabled
            }

        case SET_USERDETAILS:
            return {
                ...state,
                userDetails: action.payload.userDetails
            }

        case SET_2FA_ENABLED:
            return {
                ...state,
                is2faEnabled: action.payload
            }

        case SET_2FA_VERIFIED:
            return {
                ...state,
                is2faVerified: action.payload
            }

        case SET_SUPPLIERDETAILS:
            return {
                ...state,
                supplierDetails: action.payload
            }

        case SET_LOADING:
            return {
                ...state,
                isLoading: action.payload,

            }

        case SET_EMAIl_VERIFIED:
            return {
                ...state,
                isEmailVerified: action.payload,

            }

        case SET_LANGUAGE:
            return {
                ...state,
                language: action.payload,
            }

        case SET_OTP_TIME:
            return {
                ...state,
                otpSendTime: action.payload,

            }

        case SET_DARK_MODE:
            return {
                ...state,
                isDarkMode: action.payload,

            }


        case SET_AVAILABILITY:
            return {
                ...state,
                availablity: action.payload,

            }

        case LOGOUT:
            // localStorage.clear();
            return {
                ...state,
                isLoggedIn: false,
                useDetails: {},
                supplierDetails: {},
                token: "",
                isLoading: false,
                tempEmail: "",
                otpSendTime: "",
                isEmailVerified: false,
                is2faEnabled: false,
                is2faVerified: false,
                permissions:{}

            }
        
        case INCREMENT_SUPPLIER_CREDITS:
            return {
                ...state,
                supplierDetails: {
                    ...state.supplierDetails,
                    credits: state.supplierDetails.credits + action.payload
                }
            }
            
        case SET_SUPPLIER_CREDITS:
            return {
                ...state,
                supplierDetails: {
                    ...state.supplierDetails,
                    credits: action.payload
                }
            }
        default:
            return state;
    }
};

export default userReducer;